import React from 'react';
import projects from '../../utils/projects.json';

const Item = () => (
  <div id="portfolio">
    {Object
      .keys(projects)
      .map(key => (
        <div className="portfolio-item" key={key}>
          <img src={projects[key].image} alt="test" />
          <div>
            <h2>{projects[key].name}</h2>
            <p>{projects[key].description}
            </p>
            <div className="portfolio-tech">
              <ul>
                {Object
                  .keys(projects[key].tech)
                  .map(tech => (
                    <li>{projects[key].tech[tech]}</li>
                  ))
}
              </ul>
            </div>
          </div>

        </div>
      ))
}
  </div>
);

export default Item;



// WEBPACK FOOTER //
// ./src/components/Portfolio/item.js